<div id="new-showcase">
    <div class="container">
        <div class="dflex flex-column slider">
            <div class="carousel slide" id="slide1" data-ride="carousel">
                <!-- Indicator -->
                <ol class="carousel-indicators">
                    <li class="active" data-target="#slide1" data-slide-to="0"></li>
                    <li data-target="#slide1" data-slide-to="1"></li>
                    <li data-target="#slide1" data-slide-to="2"></li>
                    <li data-target="#slide1" data-slide-to="3"></li>
                    <li data-target="#slide1" data-slide-to="4"></li>
                    <li data-target="#slide1" data-slide-to="5"></li>
                    <li data-target="#slide1" data-slide-to="6"></li>
                </ol>
                <!-- img/video URL -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <video src="/assets/img/showcase/home_video.mp4" class="d-block img-fluid rounded w-100" autoplay muted loop playsinline></video>
                    </div>
                    <div class="carousel-item">
                        <div class="spinner" [hidden]="!imageLoader">
                            <app-loading-spinner class="detail"></app-loading-spinner>
                        </div>
                        <img appLazyload [hidden]="imageLoader" src="/assets/img/showcase/home_1.jpeg"
                            alt="RPDAV Public School students and teachers" class="d-block img-fluid rounded"
                            (load)="this.imageLoader = false;">
                    </div>
                    <div class="carousel-item">
                        <img appLazyload src="/assets/img/showcase/home_2.jpeg" alt="School Event"
                            class="d-block img-fluid rounded">
                    </div>
                    <div class="carousel-item">
                        <img appLazyload src="/assets/img/showcase/home_3.jpeg" alt="School Activities"
                            class="d-block img-fluid rounded">
                    </div>
                    <div class="carousel-item">
                        <img appLazyload src="/assets/img/showcase/home_4.jpeg" alt="School Achievement"
                            class="d-block img-fluid rounded">
                    </div>
                    <div class="carousel-item">
                        <img appLazyload src="/assets/img/showcase/home_5.jpeg" alt="School Infrastructure"
                            class="d-block img-fluid rounded">
                    </div>
                    <div class="carousel-item">
                        <img appLazyload src="/assets/img/showcase/home_6.jpeg" alt="School Assembly"
                            class="d-block img-fluid rounded">
                    </div>
                </div>
                <!-- controller -->
                <a href="#slide1" class="carousel-control-prev" data-slide="prev">
                    <span class="carousel-control-prev-icon"></span>
                </a>
                <a href="#slide1" class="carousel-control-next" data-slide="next">
                    <span class="carousel-control-next-icon"></span>
                </a>
            </div>

        </div>
    </div>
</div>